import { render, staticRenderFns } from "./LoaderView.vue?vue&type=template&id=257ae08b&scoped=true"
import script from "./LoaderView.vue?vue&type=script&lang=js"
export * from "./LoaderView.vue?vue&type=script&lang=js"
import style0 from "./LoaderView.vue?vue&type=style&index=0&id=257ae08b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257ae08b",
  null
  
)

export default component.exports